import React from "react";
import { NavLink } from "react-router-dom";
import { MdDelete, MdEdit } from "react-icons/md";

const ItemTable = ({
  id,
  productId,
  name,
  barcode,
  cost,
  price,
  quantity,
  confirmDelete,
}) => {
  return (
    <>
      <tr className="border-b last:border-none mx-2 lg:h-[5rem] h-[4rem]">
        <td
          className={`p-3  lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start   `}
        >
          {productId}
        </td>
        <td
          className={`p-3 text-wrap lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start  `}
        >
          {name}
        </td>
        <td
          className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start   `}
        >
          {barcode ? barcode : "N/A"}
        </td>
        <td
          className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start   `}
        >
          {quantity}
        </td>
        <td
          className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start   `}
        >
          {cost}
        </td>
        <td
          className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start   `}
        >
          {price}
        </td>

        <td className="p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center ">
          <div className="flex gap-2 items-center">
            <NavLink
              className="bg-[#0D868C] text-center text-white p-1 rounded-lg cursor-pointer"
              to={`/editItem/${id}`}
            >
              <MdEdit className="size-6" />
            </NavLink>
            <span
              onClick={() => confirmDelete(id, name)}
              className="bg-[#f1524d] text-center text-white p-1 rounded-lg cursor-pointer"
            >
              <MdDelete className="size-6" />
            </span>
          </div>
        </td>
      </tr>
    </>
  );
};

export default ItemTable;
